import $ from "jquery";
import axios from "axios";
import {PARTNER_WIDGET_RENDER} from "Core/links";
import {crossRecommenderHandler} from './cross-recommender';
import {isMobile} from "Core/screenSizes";
import {
    crossRecommenderClickHandler,
    crossRecommenderGetListHandler,
    crossRecommenderViewHandler
} from "../../common/dataLayer/data-layer-metrica-handlers";
import {dispatchEvent, GET_NEXT_MATERIAL_EVENT_NAME, GET_PARTNER_MATERIAL_EVENT} from "../../../common/events";

export const partnerWidgetGeneralHandlersAfterLoad = () => {
    $('.partner-widget-placeholder').each(function () {
        const materialId = $(this).parents('.material-content__parts-wrapper').data('id');

        axios.get(PARTNER_WIDGET_RENDER, {
            params: {
                type: $(this).data('place'),
                isTextCenteredMaterial: $(this).data('isCenter') === '',
            }
        })
            .then((response) => {
                $(this).replaceWith(response.data);
                dispatchEvent(GET_PARTNER_MATERIAL_EVENT, {});

                if (response.data.indexOf('pulse') !== -1) {
                    crossRecommenderGetListHandler('related', 'pulse');
                    //.pw_28.pw_29.pw_35.pw_36
                }

                if (response.data.indexOf('smi2') !== -1) {
                    crossRecommenderGetListHandler('related', 'smi2');
                    //.list-container-item
                }

                if (response.data.indexOf('lentainform') !== -1) {
                    crossRecommenderGetListHandler('related', 'lentainform');
                    //не грузиться
                }

                if (response.data.indexOf('cross-platform') !== -1) {
                    if (isMobile() && response.data.indexOf('--mobile') !== -1) {
                        crossRecommenderHandler(materialId);
                    }

                    if (!isMobile() && response.data.indexOf('--mobile') === -1) {
                        crossRecommenderHandler(materialId);
                    }
                }
            });
    });
};

export const partnerWidgetGeneralHandlers = () => {
    let observer = new IntersectionObserver(onIntersectionObserve);

    document.addEventListener(GET_NEXT_MATERIAL_EVENT_NAME, function (data) {
        $('.own-related .related-materials-in-content__item-wrapper').each(function () {

            observer.observe($(this)[0]);
        });
    });

    $('.own-related .related-materials-in-content__item-wrapper').each(function () {

        observer.observe($(this)[0]);
    });

    $(document).on('click', '.own-related .related-materials-in-content__item-wrapper', function (event) {
        const data = $(this).data();

        crossRecommenderClickHandler(data.id, data.isNews === '' ? 'post' : 'news', 'related', '');

        return true;
    });
};

const onIntersectionObserve = (entries, observer) => {
    entries.forEach(entry => {
        if (!entry.isIntersecting) {
            return;
        }

        crossRecommenderViewHandler('related', '');

        observer.unobserve(entry.target);
    });
};